var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button"},[_c('button',{on:{"click":function($event){return _vm.$root.back()}}},[_c('i',{staticClass:"icon-base bs-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("\n            Voltar\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9acb7f3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackButton.vue
// module id = null
// module chunks = 